// NOTE: This is a draft legal text. Review by a legal professional is recommended.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function TermsOfServiceEn() {
  return (
    <LegalPage
      lang="en"
      title="Terms of Service"
      subtitle="Please read these terms before using the uSeen platform."
      lastUpdated="May 2026"
      version={LEGAL_VERSIONS.terms}
      testid="terms-page-en"
    >
      <h2>1. Description of the Service</h2>
      <p>
        uSeen is an <strong>AI visibility readiness and analysis platform</strong>
        that helps local businesses be discovered accurately by AI assistants
        (ChatGPT, Claude, Gemini and similar large language models). uSeen
        produces a visibility score based on website content, technical signals
        and sector-specific questions, and suggests improvements.
      </p>

      <h2>2. Limitation of Warranty</h2>
      <p>
        uSeen does not guarantee any specific ranking, position or visibility on
        any search engine or AI assistant. The scores, tasks and content
        suggestions produced by the platform are advisory in nature; actual
        results depend on many factors including third-party platforms, market
        conditions and your own implementation.
      </p>

      <h2>3. Acceptable Use</h2>
      <p>
        You agree to use uSeen only for lawful business purposes. You agree not
        to attempt to disrupt the service, reverse-engineer protected portions
        of the platform, or use the platform to generate misleading content
        about a third party.
      </p>

      <h2>4. Accounts and Plans</h2>
      <p>
        Some features require an account and a paid plan. Pricing, scan limits
        and feature scope per plan are described on the public pricing page and
        may be updated from time to time.
      </p>

      <h2>5. Intellectual Property</h2>
      <p>
        The uSeen platform, its branding and the underlying analysis methods
        remain the property of uSeen. Content you upload or generate within
        your account remains yours; you grant uSeen a limited right to process
        it solely to deliver the service.
      </p>

      <h2>6. Termination</h2>
      <p>
        We may suspend or terminate accounts that violate these terms. You may
        close your account at any time. Closing your account does not
        automatically delete archival logs required for compliance.
      </p>

      <h2>7. Changes to the Terms</h2>
      <p>
        We may revise these terms as the product evolves. Material changes will
        be communicated via the platform or email. Continued use after a change
        means you accept the updated terms.
      </p>

      <h2>8. Contact</h2>
      <p>
        For any question about these terms, please reach us through the contact
        page.
      </p>
    </LegalPage>
  );
}
